import { SiJavascript, SiMarkdown, SiPython } from "react-icons/si";

export const openSource = {
  repos: [
    {
      id: 1,
      name: "GitHub Profile Readme Generator",
      repoName: "githubProfileReadmeGenerator",
      user: "rahulbanerjee26",
      url: "https://github.com/rahulbanerjee26/githubProfileReadmeGenerator",
      description:
        "This web app lets you build a cool README for your profile.",
      language: <SiPython size={"2em"} />,
      type: "repo",
    },
    {
      id: 2,
      name: "Alexa - Apl Suggester",
      repoName: "apl-suggester",
      user: "alexa",
      url: "https://github.com/alexa/apl-suggester/pulls?q=is%3Apr+author%3Arahulbanerjee26",
      description: "This package is developed for providing suggestions and validations on APL (Alexa Presentation Language) templates.",
      language: <SiJavascript size={"2em"}/>,
      type: "pr"
    },
    {
      id: 3,
      name: "Alexa Skills Toolkit for Visual Studio Code",
      repoName: "ask-toolkit-for-vscode",
      user: "alexa",
      url: "https://github.com/alexa/ask-toolkit-for-vscode/pulls?q=is%3Apr+author%3Arahulbanerjee26",
      description: "Alexa Skills Toolkit for Visual Studio Code is an extension that makes it easier for you to create, test, and deploy Alexa skills",
      language: <SiJavascript size={"2em"}/>,
      type: "pr"

    },
    {
      id: 4,
      name: "Microsoft - VSCode JSON Language Service",
      repoName: "vscode-json-languageservice",
      user: "microsoft",
      url: "https://github.com/microsoft/vscode-json-languageservice/pull/164",
      description: "JSON language service extracted from VSCode to be reused, e.g in the Monaco editor.",
      language: <SiJavascript size={"2em"}/>,
      type: "pr"
    },
    {
      id: 5,
      name: "Deep Translator",
      repoName: "deep-translator",
      user: "nidhaloff",
      url: "https://github.com/nidhaloff/deep-translator/pull/115",
      description:
        "A flexible FREE and UNLIMITED tool to translate between different languages in a simple way using multiple translators.",
      language: <SiPython size={"2em"} />,
      type: "pr",
    },
    {
      id: 6,
      name: "Medium Enhanced Stats",
      repoName: "medium-enhanced-stats",
      user: "tomastrajan",
      url: "https://github.com/tomastrajan/medium-enhanced-stats/pull/14",
      description: "This is a list of Awesome Tech Blogs.",
      language: <SiJavascript size={"2em"} />,
      type: "pr",
    },
    {
      id: 7,
      name: "Blogposts - Pythonengineer",
      repoName: "blogposts-pythonengineer",
      user: "python-engineer",
      url: "https://github.com/python-engineer/blogposts-pythonengineer/pull/35",
      description: "Repo with articles for the python-engineer.com website.",
      language: <SiMarkdown size={"2em"} />,
      type: "pr",
    },
    {
      id: 8,
      name: "Engineering Education",
      repoName: "engineering-education",
      user: "section-engineering-education",
      url: "https://github.com/section-engineering-education/engineering-education/pulls?q=is%3Apr+author%3Arahulbanerjee26+is%3Aclosed",
      description:
        "Section Engineering Education (EngEd) Program is dedicated to offering a unique quality community experience for computer science university students.",
      language: <SiMarkdown size={"2em"} />,
      type: "pr",
    },
    {
      id: 9,
      name: "Awesome Tech Blogs",
      repoName: "awesome-tech-blogs",
      user: "markodenic",
      url: "https://github.com/markodenic/awesome-tech-blogs/pull/76",
      description: "This is a list of Awesome Tech Blogs.",
      language: <SiMarkdown size={"2em"} />,
      type: "pr",
    },
  ],
};
